import React, { useEffect, useState } from 'react';

import { Search as SearchIcon } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { AppAction } from 'src/actions/app.action';
import { KhophieuAction } from 'src/actions/khophieu.action';
import * as XLSX from 'xlsx';

import {
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  SvgIcon,
  TextField,
  Select,
  MenuItem,
} from '@material-ui/core';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import CreateEditDialog from './CreateEditDialog';

import moment from 'moment';

import { saveAs } from 'file-saver';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { Settings, Download, Upload, Cached } from '@material-ui/icons';

import {
  DatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';

const today = new Date();
// const defaultStartDate = dayjs(new Date(today.getFullYear(), today.getMonth(), 1));
const defaultStartDate = dayjs(today);
const defaultEndDate = dayjs(today);

const KhophieuToolbar = (props) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(false);
  const [assign, setAssign] = useState(false);
  const { role, info } = useSelector(state => state.profile);
  const { isLoading } = useSelector(state => state.app);
  const [values, setValues] = useState({
    loai_phieu: "-99",
    so_phieu: "",
    ho_ten_nguoi_nhan: "",
    sdt_nguoi_nhan: "",
    dia_chi_giao: "",
    ly_do: "",
    ten_kho_xuat: "",
    dia_diem_kho_xuat: "",
    ghi_chu: "",
    trang_thai: "-99",
    startDate: dayjs(defaultStartDate, moment(new Date()).format('DD/MM/YYYY')),
    endDate: dayjs(defaultEndDate, moment(new Date()).format('DD/MM/YYYY')),
  });

  useEffect(() => {
    const today = new Date();

    const payload = {
      page: 0,
      limit: DEFAULT_ROW_PER_PAGE,
      loai_phieu: "-99",
      so_phieu: "",
      ho_ten_nguoi_nhan: "",
      sdt_nguoi_nhan: "",
      dia_chi_giao: "",
      ly_do: "",
      ten_kho_xuat: "",
      dia_diem_kho_xuat: "",
      ghi_chu: "",
      trang_thai: "-99",
      startDate: dayjs(defaultStartDate, moment(new Date()).format('DD/MM/YYYY')),
      endDate: dayjs(defaultEndDate, moment(new Date()).format('DD/MM/YYYY')),
    };
    dispatch(KhophieuAction.updateFilter(payload));
  }, []);

  const fileInput = React.useRef();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleImportFile = (e) => {
    e.preventDefault();
    dispatch(AppAction.appLoading(true))
    const files = e.target.files, f = files[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      let data = e.target.result;
      let readedData = XLSX.read(data, { type: 'binary' });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      /* Convert array to json*/
      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const temp = dataParse.splice(1).map((c) => ({
        phone: c[1],
        type: c[2],
        package: c[3],
        registerAt: c[4],
        expiredAt: c[5],
        packageCycle: c[6],
        state: c[7],
        status: "NORMAL",
        packageCanRegister: c[8]
      }));
      dispatch(KhophieuAction.importData(temp));
      dispatch(AppAction.appLoading(false))
      setPreview(true)
      e.target.value = null;
    };
    reader.readAsBinaryString(f)
  }

  const handleClosePreview = () => {
    fileInput.current.value = null;
    setPreview(false)
  }

  const handleCloseAssign = () => {
    fileInput.current.value = null;
    setAssign(false)
  }

  const handleOpenAssign = () => {
    dispatch(KhophieuAction.countAssign())
    setAssign(true)
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleInputChange1 = (name, value) => {
    setValues({
      ...values,
      [name]: value
    });
  };

  const onLookup = () => {
    const payload = {
      page: 'no_update',
      limit: 'no_update',
      loai_phieu: values.loai_phieu,
      so_phieu: values.so_phieu,
      ho_ten_nguoi_nhan: values.ho_ten_nguoi_nhan,
      sdt_nguoi_nhan: values.sdt_nguoi_nhan,
      dia_chi_giao: values.dia_chi_giao,
      ly_do: values.ly_do,
      ten_kho_xuat: values.ten_kho_xuat,
      dia_diem_kho_xuat: values.dia_diem_kho_xuat,
      ghi_chu: values.ghi_chu,
      trang_thai: values.trang_thai,
      startDate: values.startDate.format("DD/MM/YYYY"),
      endDate: values.endDate.format("DD/MM/YYYY"),
    };
    dispatch(KhophieuAction.updateFilter(payload));
    dispatch(KhophieuAction.list())
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onLookup();
    }
  };

  const xuatFile = async () => {
    if (role.priority == 5) return;
    dispatch(AppAction.appLoading(true))
    try {
      const payload = {
        page: 0,
        limit: 9999999999,
        loai_phieu: values.loai_phieu,
        so_phieu: values.so_phieu,
        ho_ten_nguoi_nhan: values.ho_ten_nguoi_nhan,
        sdt_nguoi_nhan: values.sdt_nguoi_nhan,
        dia_chi_giao: values.dia_chi_giao,
        ly_do: values.ly_do,
        ten_kho_xuat: values.ten_kho_xuat,
        dia_diem_kho_xuat: values.dia_diem_kho_xuat,
        ghi_chu: values.ghi_chu,
        trang_thai: values.trang_thai,
        startDate: values.startDate.format("DD/MM/YYYY"),
        endDate: values.endDate.format("DD/MM/YYYY"),
      };
      dispatch(KhophieuAction.updateFilter(payload));
      const response = await dispatch(KhophieuAction.list());
      console.log(response)

      const data = [
        [
          '#', 
          'Số điện thoại', 
          'Gói cước', 
          'Giá gói cước', 
          'Kênh', 
          'Ngày thành công',
          'Username NV',
          'Tên NV',
          'Lý do',
          'Trạng thái',
          'Người đặt trạng thái',
          'Ngày tạo',
          'Người phê duyệt',
          'Trạng thái duyệt',
        ],
      ];

      if (typeof response !== 'undefined' && response != null && typeof response.data !== 'undefined' && response.data && typeof response.data.values !== 'undefined' && response.data.values && response.data.values.length > 0) {
        var count = 1;
        response.data.values.forEach((element) => {
          let trangThai = "";
          let trangThaiDuyet = "";

          if (element.trang_thai == '0') trangThai = "Chưa đặt";
          else if (element.trang_thai == 'SUCCESS') trangThai = "Thành công";
          else if (element.trang_thai == 'FAILED') trangThai = "Thất bại";

          if (element.trang_thai_duyet == '1') trangThaiDuyet = "Đã duyệt";
          else if (element.trang_thai_duyet == '2') trangThaiDuyet = "Từ chối";
          
          let pushData = [
            count,
            element.so_dien_thoai,
            element.ten_goi_cuoc,
            element.gia_goi_cuoc,
            element.kenh,
            moment(element.ngay_thanh_cong).format('DD-MM-YYYY HH:mm:ss'),
            element.username_nv,
            element.ten_nv,
            element.ly_do,
            trangThai,
            element.nguoi_dat_trang_thai,
            moment(element.created_at).format('DD-MM-YYYY HH:mm:ss'),
            element.nguoi_phe_duyet,
            trangThaiDuyet,
          ];

          data.push(pushData)
          count++;
        })

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Bao-cao-bao-do.xlsx');
      }

      dispatch(AppAction.appLoading(false))
    } catch (error) {
      if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
    }
  }

  const setColor = (value) => {
      if (value == 'cho_duyet') return 'orange';
      else if (value == 'da_duyet') return 'green';
      else if (value == 'tu_choi') return 'red';
      else if (value == 'positive') return 'green';
      else if (value == 'negative') return 'red';
      else return '#000000';
  };

  return (
    <Box {...props}>
      <Box sx={{ mt: 3 }}>
        <Card className="filter_card">
          <CardContent>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <PerfectScrollbar>
                <Box sx={{ maxWidth: 500 }}>
                <Select
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                    name="loai_phieu"
                    value={values.loai_phieu || -99}
                    onChange={handleInputChange}
                    variant="outlined"
                    startAdornment={(
                      <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                          <SearchIcon />
                        </SvgIcon>
                      </InputAdornment>
                    )}
                  >
                    <MenuItem value="-99">Loại phiếu...</MenuItem>
                    <MenuItem style={{ }} value="nhap_kho">Nhập kho</MenuItem>
                    <MenuItem style={{ }} value="xuat_kho">Xuất kho</MenuItem>
                  </Select>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="so_phieu"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={values.so_phieu}
                    placeholder="Tìm số phiếu"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="ho_ten_nguoi_nhan"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={values.ho_ten_nguoi_nhan}
                    placeholder="Tìm họ tên người nhận"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="sdt_nguoi_nhan"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={values.sdt_nguoi_nhan}
                    placeholder="Tìm SĐT người nhận"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="dia_chi_giao"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={values.dia_chi_giao}
                    placeholder="Tìm địa chỉ giao"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="ly_do"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={values.ly_do}
                    placeholder="Tìm lý do"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="ten_kho_xuat"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={values.ten_kho_xuat}
                    placeholder="Tìm tên kho xuất"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="dia_diem_kho_xuat"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={values.dia_diem_kho_xuat}
                    placeholder="Tìm địa điểm kho xuất"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                            >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    name="ghi_chu"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    value={values.ghi_chu}
                    placeholder="Tìm ghi chú"
                    variant="outlined"
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 0 }}
                  />
                  <Select
                    style={{ height: 56, marginTop: 6, width: "200px", marginLeft: 15 }}
                    name="trang_thai"
                    value={values.trang_thai || -99}
                    onChange={handleInputChange}
                    variant="outlined"
                    startAdornment={(
                      <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                          <SearchIcon />
                        </SvgIcon>
                      </InputAdornment>
                    )}
                  >
                    <MenuItem value="-99">Trạng thái...</MenuItem>
                    <MenuItem style={{ color: setColor('cho_duyet') }} value="cho_duyet">Chờ duyệt</MenuItem>
                    <MenuItem style={{ color: setColor('da_duyet') }} value="da_duyet">Đã duyệt</MenuItem>
                    <MenuItem style={{ color: setColor('tu_choi') }} value="tu_choi">Từ chối</MenuItem>
                  </Select>
                  <DatePicker
                    label="Thời gian bắt đầu"
                    style={{ width: '200px' }}
                    format='DD/MM/YYYY'
                    value={values.startDate}
                    onChange={(newValue) => handleInputChange1('startDate', newValue)}
                    onKeyDown={handleKeyDown}
                  />
                  <DatePicker
                    label="Thời gian kết thúc"
                    style={{ width: '200px' }}
                    value={values.endDate}
                    format='DD/MM/YYYY'
                    onChange={(newValue) => handleInputChange1('endDate', newValue)}
                    onKeyDown={handleKeyDown}
                  />
                </Box>
              </PerfectScrollbar>
            </LocalizationProvider>
          </CardContent>
        </Card>
        <Card>
          <div className='functional-btn-container' style={{width: '250px', margin: 'auto'}}>
            <Button
              color="primary"
              variant="contained"
              onClick={handleClickOpen}
              style={{ height: '20px', padding: 0, marginTop: 0, width: "150px", minWidth: '20px', marginLeft: '0', backgroundColor: 'orange', fontWeight: 'normal' }}
              >
              Tạo bản ghi
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={onLookup}
              style={{ background: !isLoading ? 'transparent' : 'url(/static/images/loading.gif) no-repeat center center / contain', height: '20px', padding: 0, marginTop: 0, width: '20px', minWidth: '20px', marginLeft: '5px', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: '20px' }}
              >
              {!isLoading ? <Cached style={{ color: "#3498db" }} /> : ''}
            </Button>
          </div>
        </Card>
      </Box>
      <CreateEditDialog open={open} handleClose={handleClose} type={"CREATE"} />
    </Box>
  )
};

export default KhophieuToolbar;
